// Guest-mode progress: attempts stored locally.
const KEY = "aeis_guest_attempts";

export function loadGuestAttempts() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
  catch { return []; }
}

export function addGuestAttempt(a) {
  const list = loadGuestAttempts();
  list.push({ ...a, created_at: new Date().toISOString() });
  localStorage.setItem(KEY, JSON.stringify(list.slice(-500)));
}

export function clearGuestAttempts() {
  localStorage.removeItem(KEY);
}
